import { useState } from "react";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";
// import { ErrorModal } from "../../../main/components/ErrorModal";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";

export function RemoveCollaboratorsModals(props: {
  onConfirmRemoveCollaborator: () => Promise<void>;
  showRemoveCollaboratorModal: boolean;
  setShowRemoveCollaboratorModal: (value: boolean) => void;
  collaboratorName: string;
  onMount: () => void;
}) {
  const {
    onConfirmRemoveCollaborator: onConfirmRemoveCollaborator,
    showRemoveCollaboratorModal: showRemoveCollaboratorModal,
    setShowRemoveCollaboratorModal: setShowRemoveCollaboratorModal,
    collaboratorName: collaboratorName,
    onMount,
  } = props;
  const [
    showRemoveCollaboratorSuccesModal,
    setShowRemoveCollaboratorSuccessModal,
  ] = useState<boolean>(false);
  const [
    showRemoveCollaboratorErrorModal,
    setShowRemoveCollaboratorErrorModal,
  ] = useState<boolean>(false);
  return (
    <>
      <ConfirmationModal
        contentText={`Deseja realmente remover o colaborador ${collaboratorName} ?`}
        open={showRemoveCollaboratorModal}
        onConfirm={onConfirmRemoveCollaborator}
        setOpen={setShowRemoveCollaboratorModal}
        title="Remover Colaborador"
        setOpenErrorModal={setShowRemoveCollaboratorErrorModal}
        setOpenSuccessModal={setShowRemoveCollaboratorSuccessModal}
      />
      <ActionAlert
        message="O colaborador foi removido com sucesso"
        severity="success"
        open={showRemoveCollaboratorSuccesModal}
        setOpen={setShowRemoveCollaboratorSuccessModal}
        onClose={() => {
          setShowRemoveCollaboratorModal(false);
          onMount();
        }}
      />
      <ActionAlert
        message="Ocorreu um erro ao remover o colaborador do usuário"
        severity="error"
        open={showRemoveCollaboratorErrorModal}
        setOpen={setShowRemoveCollaboratorErrorModal}
        onClose={() => {
          setShowRemoveCollaboratorModal(false);
        }}
      />
      {/* <ErrorModal
        contentText="Ocorreu um erro ao remover o colaborador do usuário"
        open={showRemoveCollaboratorErrorModal}
        setOpen={setShowRemoveCollaboratorErrorModal}
        title="Erro ao remover o colaborador"
        onClose={() => {
          setShowRemoveCollaboratorModal(false);
        }}
      />
      <SuccessModal
        contentText="O colaborador foi removido com sucesso"
        open={showRemoveCollaboratorSuccesModal}
        setOpen={setShowRemoveCollaboratorSuccessModal}
        title="Colaborador removido"
        onClose={() => {
          setShowRemoveCollaboratorModal(false);
          onMount();
        }}
      /> */}
    </>
  );
}
